/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * Root State
 *
 * @type {Object}
 */
const state = {
    pending: false,
    error: false,
    popup: {
        show: false,
        data: {}
    },
    data: [],
    showActivity: false
}

export const getState = () => {
    return cloneDeep(state)
}

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/activity/state.js